module.exports = __webpack_public_path__ + "static/media/PublicSans-Bold.8296f9b4.woff";